<footer class="site-footer footer-large  footer-light	footer-wide text-black">
  
  <!-- FOOTER BLOCKES START -->  
  <div class="footer-top overlay-wraper">
      <div class="overlay-main"></div>
      
      
     
      
      <div class="container">
          <div class="row">
              <!-- ABOUT COMPANY -->
              <div class="col-lg-5 col-md-5 col-sm-4">  
                  <div class="widget widget_about">
                      <!--<h4 class="widget-title">About Company</h4>-->
                      <div class="logo-footer clearfix p-b15">
                          <!-- <a routerLink="/index"><img src="assets/images/logo-dark.png" alt=""></a> -->
                          <h1> Dream Builders</h1>
                      </div>
                      <p>Today we can tell you, thanks to your passion, hard work creativity, and expertise, you delivered us the most beautiful house great looks. lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                    <ul class="social-icons f-social-link">
                          <li><a href="javascript:void(0);" class="fa fa-google"></a></li>
                          <li><a href="javascript:void(0);" class="fa fa-rss"></a></li>
                          <li><a href="javascript:void(0);" class="fa fa-facebook"></a></li>
                          <li><a href="javascript:void(0);" class="fa fa-twitter"></a></li>
                          <li><a href="javascript:void(0);" class="fa fa-linkedin"></a></li>
                      </ul>                                    
                  </div>
           
              </div> 

              <!-- TAGS -->
              <div class="col-lg-4 col-md-4 col-sm-4">
                  <div class="widget widget_address_outer m-b20">
                      <h4 class="widget-title">Contact Us</h4>
                      <ul class="widget_address">
                          <li>Ramanathapuram</li>
                          <li>dreambuilders@gmail.com</li>
                          <li>(+0091) 123-3456-073</li>
                          <li>(+0091) 123-3456-084</li>
                      </ul>
                 
                  </div>
              </div>
                                      
              <!-- USEFUL LINKS -->
              <div class="col-lg-3 col-md-3 col-sm-4">
                  <div class="widget widget_services inline-links">
                      <h4 class="widget-title">Useful links</h4>
                      <ul>
                          <li><a>About</a></li>
                          <li><a>Gallery</a></li>
                          <li><a>Blog</a></li>
                          <li><a>Portfolio</a></li>
                          <li><a>Contact Us</a></li>
                          <!-- <li><a routerLink="/about-1">About</a></li>
                          <li><a routerLink="/post-gallery">Gallery</a></li>
                          <li><a routerLink="/news-grid">Blog</a></li>
                          <li><a routerLink="/work-masonry">Portfolio</a></li>
                          <li><a routerLink="/contact-1">Contact Us</a></li> -->
                      </ul>
                  </div>                           
              </div>      

              <!-- NEWSLETTER -->

          </div>
          <div class="m-b10">
              <div class="wt-divider bg-gray-dark"><i class="icon-dot c-square"></i></div>
          </div>
          <!-- <div class="news-letter-footer">
              <div class="row">
                <div class="col-md-6 col-sm-6">
                    <div class="newsletter-f-left">
                          <h4 class="text-uppercase m-t0 m-b10">Subscribe to our newsletter!</h4>
                          <p>Never Miss Anything From Construx By Signing Up To Our Newsletter. </p>
                      </div>
                  </div>    
                  <div class="col-md-6 col-sm-6">
                      <div class="newsletter-f-right text-center">
                          <form role="search">
                              <div class="input-group">
                                  <input  class="form-control" placeholder="ENTER YOUR EMAIL" type="text">
                                  <span class="input-group-btn">
                                      <button type="submit" class="site-button site-btn-effect"><span>Submit</span></button>
                                  </span>
                              </div>
                           </form>
                      </div>
                  </div>
              </div>                           
          </div> -->
      </div>
  </div>
  <!-- FOOTER COPYRIGHT -->
  <div class="footer-bottom overlay-wraper">
      <div class="overlay-main"></div>
      <div class="container">
          <div class="row">
              <div class="wt-footer-bot-center">
                  <span class="copyrights-text">© 2023 Your Company. Designed By Salih Solutions</span>
              </div>
          </div>
      </div>
  </div>
</footer>